import api from "./axios";

/*
|--------------------------------------------------------------------------
| REPORTS
|--------------------------------------------------------------------------
*/

export const getDailyWorkingReport = (params = {}) =>
    api.get("/reports/daily-working", {
        params,
    });

export const getVisitReport = (params = {}) =>
    api.get("/reports/visits", {
        params,
    });

export const getExpenseReport = (params = {}) =>
    api.get("/reports/expenses", {
        params,
    });

export const getTaDaReport = (params = {}) =>
    api.get("/reports/ta-da", {
        params,
    });

export const getPaymentReport = (params = {}) =>
    api.get("/reports/payments", {
        params,
    });

export const getCollectionReport = (params = {}) =>
    api.get("/reports/collections", {
        params,
    });

export const getAppraisalReport = (params = {}) =>
    api.get("/reports/appraisals", {
        params,
    });

export const getSampleReport = (params = {}) =>
    api.get("/reports/samples", {
        params,
    });

export const getAttendanceReport = (params = {}) =>
    api.get("/reports/attendance", {
        params,
    });

export const getGpsComplianceReport = (params = {}) =>
    api.get("/reports/gps-compliance", {
        params,
    });

export const getJourneyComplianceReport = (params = {}) =>
    api.get("/reports/journey-compliance", {
        params,
    });

export const getSalesPersonPerformanceReport = (
    params = {}
) =>
    api.get("/reports/sales-person-performance", {
        params,
    });

/*
|--------------------------------------------------------------------------
| EXPORT
|--------------------------------------------------------------------------
*/

export const exportReport = (data) =>
    api.post("/reports/export", data);

export const getReportExports = (params = {}) =>
    api.get("/reports/exports", {
        params,
    });

/*
|--------------------------------------------------------------------------
| STATEMENTS
|--------------------------------------------------------------------------
*/

export const createStatement = (data) =>
    api.post("/reports/statements", data);

export const getStatements = (params = {}) =>
    api.get("/reports/statements", {
        params,
    });

export const getStatement = (id) =>
    api.get(`/reports/statements/${id}`);

export const downloadStatement = (id) =>
    api.get(
        `/reports/statements/${id}/download`,
        {
            responseType: "blob",
        }
    );

/*
|--------------------------------------------------------------------------
| DAILY WORKING REPORT - SUMMARY
|--------------------------------------------------------------------------
| One row = Employee + Date
*/
export const getDailyWorkingSummary = async (params = {}) => {
    const response = await api.get(
        "/reports/daily-working/summary",
        {
            params,
        }
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| DAILY WORKING REPORT - DETAILS
|--------------------------------------------------------------------------
| One employee + one date
| Returns all visits + all expenses
*/
export const getDailyWorkingDetails = async (
    employeeId,
    date
) => {
    if (!employeeId || !date) {
        throw new Error(
            "Employee ID and date are required."
        );
    }

    const response = await api.get(
        `/reports/daily-working/${encodeURIComponent(
            String(employeeId)
        )}/${encodeURIComponent(String(date))}`
    );

    return response?.data;
};